import {Box, Paper, Typography, IconButton} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import {Link, useParams, useLocation} from 'react-router-dom'
import {searchSubmissionLogs} from '../SubmissionCRUD'
import {SubmissionHistoryTable} from '../components/SubmissionHistoryTable/SubmissionHistoryTable'
import {useControlledFilterTableApi} from '../../../components/table/ControlledFilterTable/useControlledFilterTableApi'
import { SearchResultModel } from '../../../models/SearchResultModel'
import { SubmissionLogModel } from '../../../models/SubmissionLogModel'
import { useEffect, useRef } from 'react'

export const SubmissionHistoryPage = () => {
  const {submissionCode} = useParams<{submissionCode: string}>()
  const location = useLocation();

  const defaultSearchResult: SearchResultModel<SubmissionLogModel> = {
    total: 0,
    limit: 0,
    page: 0,
    data: []
  }

  const table = useControlledFilterTableApi({
    onFilter: async (filters) => {
      if (submissionCode) {
        const {data} = await searchSubmissionLogs(submissionCode, filters)
        return data
      }
      return defaultSearchResult
    },
  })

  const prevSubmissionCodeRef = useRef(submissionCode)
  const isDesiredPath = location.pathname === `/submissions/${submissionCode}/history`

  //dont add dependencies
  useEffect(() => {
    if (isDesiredPath) {
      table.refresh()
    }
  }, [])

  useEffect(() => {
    if (prevSubmissionCodeRef.current !== submissionCode) {
      table.refresh()
      prevSubmissionCodeRef.current = submissionCode
    }
  }, [submissionCode])


  return (
    <Paper
      sx={{
        p: 3,
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        '& > *': {
          '&:not(:last-child)': {
            mb: 3,
          },
        },
      }}
    >
      <Box>
        <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
          <Typography variant='h4' fontWeight='bold' textTransform='uppercase'>
            History
          </Typography>
          <IconButton
            size='large'
            color='primary'
            component={Link}
            to='/submissions'
            id='link-submission-view-page-close'
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </Box>

        <SubmissionHistoryTable id='submission-history-table' {...table} />

    </Paper>
  )
}

export default SubmissionHistoryPage
